require('lightslider/dist/js/lightslider.min');

function productGallery() {
    $("#productGallery").lightSlider({
        gallery: true,
        item: 1,
        loop: true,
        auto: true,
        pauseOnHover: true,
        controls: true,
        slideMargin: 0,
        thumbItem: 6,
        adaptiveHeight: true
    });
}

function formatPrice() {
    $('.format-price').each(function () {
        let value = $(this).html();
        if (value !== "") {
            $(this).html(parseInt(value).formatMoney());
        }
        $(this).removeClass('format-price')
    });
}

function rating() {
    $('input.bs-rating').rating({
        readonly: true,
        displayOnly: true,
        defaultCaption: '{rating}',
        min: 0,
        max: 5,
        step: 0.01,
        starCaptions: function (val) {
            return numeral(val).format('0.00');
        }
    });
}

function showMoreContent(){
    $('.btn-show-more-content').on('click', function () {
        let e = $(this).data('id')
        $(e).removeClass('content-less');
        $(this).remove();
    })
}


$(document).ready(function () {
    //init
    productGallery();
    formatPrice();
    rating();
    showMoreContent();
})
